import styles from "@coworker/apprestructured/src/media-maintenance/styles/common-media-styles.module.css";
import { ItemImageLocalCombination } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemImageLocalCombination/ItemImageLocalCombination";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { formatProductIdWithDots } from "@coworker/reusable/formatters/product.formatter";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import React from "react";
import { ItemTotalInMedia } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemTotalInMedia/ItemTotalInMedia";
import {
  ArticleWithMediaCount,
  EdsData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import FixaLink from "@coworker/apprestructured/src/shared/wrappers/FixaLink/FixaLink";
import { MediaItemEds } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemEds/MediaItemEds";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";

interface MediaItemCardLocalCombinationSearchProps {
  article: ArticleWithMediaCount;
  edsData?: EdsData | null;
  badges?: ItemBadge[];
}

export const MediaItemCardLocalCombinationSearch = ({
  article,
  edsData,
  badges,
}: MediaItemCardLocalCombinationSearchProps) => {
  const navigationUrl = `/mediamaintenance/articles/search/${article.productArticleId}`;

  return (
    <ItemCard
      badges={badges || []}
      dataTestId={"media-item-card-local-combination-search"}
    >
      <FixaLink to={navigationUrl} className={styles["item-card-root-row"]}>
        <ItemImageLocalCombination />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={article.itemName} />
          <ItemNo itemNo={formatProductIdWithDots(article.productArticleId)} />
          <ItemTotalInMedia amountOfMedias={article.inAmountOfMedias} />
          {edsData && <MediaItemEds edsData={edsData} />}
        </div>
      </FixaLink>
    </ItemCard>
  );
};
